import {createFileRoute} from '@tanstack/react-router'
import {firstLevelIndexRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/wants/$username/$primarySorting/')({
    ...firstLevelIndexRoute("/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
});
